import { render } from "./PortfolioDetail.vue?vue&type=template&id=488e80b0"
import script from "./PortfolioDetail.vue?vue&type=script&lang=js"
export * from "./PortfolioDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__